import { onBeforeUnmount, onMounted } from "vue";

export function onClickOutside(targetRef, handler) {
  const listener = event => {
    const element = targetRef.value;
    if (!element || element.contains(event.target)) return;
    handler(event);
  };
  onMounted(() => document.addEventListener("pointerdown", listener));
  onBeforeUnmount(() => document.removeEventListener("pointerdown", listener));
}
